import React from "react";
import cn from "classnames";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import styles from "./Layout.module.scss";

interface LayoutProps {
    pageName?: string;
    pageId?: string;
    headerClassName?: string;
    mainClassName?: string;
    footerClassName?: string;
    staticMobileHeader?: boolean;
    showRebrand?: boolean;
}

const Layout = (props: LayoutProps & React.PropsWithChildren<React.ComponentProps<typeof Header>>) => {
    const {
        children,
        pageName,
        pageId = "main-content",
        headerClassName,
        mainClassName,
        footerClassName,
        ...headerProps
    } = props;

    return (
        <div className={cn(styles.pageWrapper, pageName)}>
            <Header
                mainContainerId={pageId}
                className={headerClassName}
                {...headerProps}
            />
            <main id={pageId} className={cn(styles.pageContent, mainClassName)}>
                {children}
            </main>

            <Footer className={footerClassName} />
        </div>
    );
};

export { Layout as default };
export type { LayoutProps };
